import { useState } from "react";

const useHandleForm = (data, createCallback, modifyCallback, invalidDataCallback) => {

    const isCreate = !Boolean(data);

    const createInitialData = () => {

        const getInitialFieldData = (fieldName) => {
            return (isCreate || !data[fieldName]) ? "" : data[fieldName];
        }

        const fieldNames = [
            "content",
            "contentHTML",
        ];

        return fieldNames.reduce((initialData, fieldName) => {
            return ({
                ...initialData,
                [fieldName]: getInitialFieldData(fieldName)
            })
        }, {});
    }

    const [formData, setFormData] = useState(createInitialData());

    const dataIsValid = () => {
        return Boolean(formData.content);
    }

    const submit = () => {
        if (dataIsValid()) {
            isCreate ? createCallback(formData) : modifyCallback(formData);
            return true;
        } else {
            invalidDataCallback();
            return false;
        }
    }

    const setFormValue = (value) => {
        setFormData({
            ...formData,
            content: value.content,
            contentHTML: value.contentHTML,
        })
    }

    return { isCreate, formData, setFormValue, submit };
}

export default useHandleForm;
